import { SessionStorageFacade } from '../../../../facades/storage/sessionStorageFacade';

const SESSION_STORAGE_DEV_TOOLS_KEY = 'Coop:DevTools';

const states = ['minimized', 'maximized', 'hidden'] as const;

interface DevToolsSavedPreferences {
    state: (typeof states)[number];
    activePanel: 'a11y' | 'mocked-modes' | 'feature-flags' | 'ab-test-previews' | undefined;
}

const getAllPreferences = () => {
    const saved = SessionStorageFacade.instance.getObject<DevToolsSavedPreferences>(
        SESSION_STORAGE_DEV_TOOLS_KEY,
    );

    if (!saved || (saved && !states.includes(saved.state))) {
        const newState = {
            state: 'minimized',
            activePanel: undefined,
        } as DevToolsSavedPreferences;

        saveAllPreferences(newState);

        return newState;
    }

    return saved;
};

const saveAllPreferences = (preferences: DevToolsSavedPreferences) => {
    SessionStorageFacade.instance.addObject(SESSION_STORAGE_DEV_TOOLS_KEY, preferences);
};

export const coopDevToolsSession = {
    getOpenPreference: () => {
        return getAllPreferences().state;
    },
    saveOpenPreference: (value: DevToolsSavedPreferences['state']) => {
        saveAllPreferences({
            ...getAllPreferences(),
            state: value,
        });
    },
    saveActivePanel: (value: DevToolsSavedPreferences['activePanel']) => {
        saveAllPreferences({
            ...getAllPreferences(),
            activePanel: value,
        });
    },
    getActivePanel: () => {
        return getAllPreferences()?.activePanel;
    },
};
